'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SharingDialog = require('./SharingDialog.component');

var _SharingDialog2 = _interopRequireDefault(_SharingDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SharingDialog2.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@dhis2/d2-ui-sharing-dialog/index.js
// module id = 973
// module chunks = 0